export const validatePhoneNumber = (event, setErrors) => {
	const { name, value, } = event.target;

	if (/[^0-9()+\s-]/.test(value)) {
		setErrors(prev => ({ ...prev, [name]: "Invalid phone number format" }));
	} else {
		setErrors(prev => ({ ...prev, [name]: null }));
	}
};
